// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3c0mu","upload":"Small_upload__2-7Kp","imageWrap":"Small_imageWrap__fUw9r","removeBtn":"Small_removeBtn__1iK0U"};